export default __webpack_public_path__ + "static/media/green-check-icon.899ebdd3.svg";